/* global getGAEventTrackingCode */

/* eslint-disable */
import 'expose-loader?jQuery!imports-loader?this=>window!../../../legacy/src/js/vendor/jquery.1.11.1.min.js'; // TODO Gross, move this over
import 'script-loader?../../../legacy/src/js/vendor/jquery.1.11.1.min.js'; // TODO Gross, move this over
import 'imports-loader?this=>window!expose-loader?getGAEventTrackingCode!exports-loader?getGAEventTrackingCode!../../../legacy/src/legacy/js/functions.js'; // eslint-disable-line max-len
import 'expose-loader?HG.EventTracking!exports-loader?HG.EventTracking!../../../legacy/src/js/HG.EventTracking.js';
import 'expose-loader?HG_PPC_Maps!exports-loader?HG_PPC_Maps!../../../legacy/src/legacy/js/HG_get_quotes_ppc.js';
/* eslint-enable */

const HG = window.HG || (window.HG = {});
const $ = window.jQuery;
window.$ = $;
const gaCategory = 'Post Job';
const gaAction = `${gaCategory} -`;
const gaLabel = gaAction;

import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import CategoryGQAutocomplete from './components/getquotes-category-autocomplete';
import PostcodeAutocomplete from './components/postcode-autocomplete';
import { getGetQuotesFormUrl } from './utils/url';
import preloadImage from '../../_common/scripts/utils/preload-image';

// import slick
import 'slick-carousel/slick/slick';

class GetQuotes {
  init() {
    $(() => {
      const recommendationsSlick = {
        centerMode: true,
        slidesToShow: 5,
        focusOnSelect: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        swipeToSlide: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerMode: true,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              centerMode: true,
              slidesToShow: 1
            }
          }
        ]
      };
      const useAjax = window.RECOMENDATION_AJAX || false;

      if (useAjax) {
        const attachAfter = $('.search-bar');
        const templateHtml = $($('#js_recommend_template').html());
        const blockHtml = $($('#js_recommend_block').html());
        const wrapper = blockHtml.find('.js_recommend_wrapper');

        $.ajax({
          type: 'GET',
          url: `/get_recommendations/${window.CATEGORY_SEO_KEY}/?items=10`,
          dataType: 'json',
          success(results, status) {
            if (status === 'success' && results.length > 0) {
              results.forEach((result) => {
                const item = templateHtml.clone();
                item.find('.recommendations__card-block').css('background-image', `url('${result.backgroundImage}')`);
                item.find('.recommendations__card-category').html(result.category);
                item.find('.recommendations__card-text').append(result.text);
                item.find('.recommendations__card-date').html(result.date);
                item
                  .find('.recommendations__card-user-initial')
                  .addClass(`user-initial__${result.userInitial}`)
                  .html(result.userInitial.toUpperCase());
                item.find('.recommendations__card-user').html(result.user);
                item.find('.recommendations__card-suburb').html(result.suburb);
                wrapper.append(item);
              });
              // attach block after search-bar
              attachAfter.after(blockHtml);
              $('.recommendations').slick(recommendationsSlick);
            }
          }
        });
      } else {
        $('.recommendations').slick(recommendationsSlick);
      }

      $('.how-it-works__row').slick({
        slidesToShow: 3,
        swipeToSlide: false,
        autoplay: false,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 770,
            settings: {
              slidesToShow: 1,
              dots: true
            }
          }
        ]
      });

      const heroGetQuotesPostcodeAutocomplete = document.getElementById('heroGetQuotesPostcodeAutocomplete');
      const postcodeBoxValue = heroGetQuotesPostcodeAutocomplete ?
              heroGetQuotesPostcodeAutocomplete.dataset.location : '';
      const postcodeBoxValueStacked = heroGetQuotesPostcodeAutocomplete ?
              heroGetQuotesPostcodeAutocomplete.dataset.stackedlocation : '';

      // init react elements
      // hero
      if (heroGetQuotesPostcodeAutocomplete) {
        ReactDOM.render(
          <PostcodeAutocomplete
            value={postcodeBoxValue}
            valueStacked={postcodeBoxValueStacked}
            classPrefix="hero__gq-postcode"
            GACategory={gaCategory}
            GAAction={`${gaAction} Select Autocomplete Hero - PPC`}
            GALabel={`${gaLabel} Select Autocomplete Hero - PPC`}
          />,
          heroGetQuotesPostcodeAutocomplete
        );
      }

      ReactDOM.render(
        <CategoryGQAutocomplete
          classPrefix="search-bar__category"
          placeholder="Search for a Plumber, Electrician, Carpenter etc"
        />,
        document.getElementById('getQuotesAutocomplete')
      );

      $('#heroGetQuotes').on('submit', (e) => {
        e.preventDefault();
        getGAEventTrackingCode(gaCategory, `${gaAction} Form Submit Hero - PPC`, `${gaLabel} Form Submit Hero - PPC`);
        const formPath = $('#heroGetQuotes').attr('action');
        const inputValue = $('#heroGetQuotes  .hero__gq-postcode__input').val();
        window.location.href = getGetQuotesFormUrl(window.location.search, formPath, inputValue);
      });

      $('#getQuotes').on('submit', (e) => {
        e.preventDefault();
        getGAEventTrackingCode(
          gaCategory,
          `${gaAction} Form Submit Search Bar - PPC`,
          `${gaLabel}  Submit Search Bar - PPC`
        );
        const formPath = $('#getQuotes').attr('action');
        const categoryKey = $('#getQuotes .search-bar__category-key')
          .val()
          .toLowerCase();
        const queryStr = window.location.search;
        const inputVal = $('#getQuotes .search-bar__category__input').val();
        if (queryStr.length > 0 && categoryKey) {
          window.location.href = `/find/${categoryKey}${formPath}${queryStr}`;
        } else if (categoryKey) {
          window.location.href = `/find/${categoryKey}${formPath}`;
        } else if (queryStr.length > 0) {
          window.location.href = `${formPath}${queryStr}&search_str=${inputVal}`;
        } else {
          window.location.href = `${formPath}?search_str=${inputVal}`;
        }
      });

      $('#mobileHeaderNavBtn').on('click', function () {
        $('#mobileHeaderSearch').removeClass('hui-header__mobile-content--open');
        if ($(this).hasClass('hui-header__mobile-burger--selected')) {
          $(this).removeClass('hui-header__mobile-burger--selected');
          $('#mobileHeaderNav').removeClass('hui-header__mobile-content--open');
        } else {
          $(this).addClass('hui-header__mobile-burger--selected');
          $('#mobileHeaderNav').addClass('hui-header__mobile-content--open');
        }
      });

      $('.hero__gq-postcode__input').trigger('focus');
    });
  }
}

HG.GetQuotes = new GetQuotes();
if (!window.Promise || !Object.assign || !Object.keys) {
  require.ensure(
    ['core-js/shim'],
    (require) => {
      // Ensure only makes sure the module has been downloaded and parsed.
      // Now we actually need to run it to install the polyfill.
      require('core-js/shim'); // eslint-disable-line
      // Carry on
      HG.GetQuotes.init();
      preloadImage(window, $, false);
    },
    'gq-poly'
  );
} else {
  HG.GetQuotes.init();
  preloadImage(window, $, false);
}



// WEBPACK FOOTER //
// ./get-quotes/scripts/main.js